import React, { useEffect, useState } from "react";
import { adminApi } from "../../lib/api";
import { useDialog } from "../../lib/dialog";
import AdminLayout from "../../components/app/AdminLayout";
import { Card, Loader } from "./Dashboard";
import { Send, Users } from "lucide-react";

export default function TalentPool() {
  const dialog = useDialog();
  const [data, setData] = useState(null);
  const [sent, setSent] = useState(null);
  useEffect(() => { adminApi.get("/admin/talent-pool").then(({ data }) => setData(data)); }, []);

  const blast = async () => {
    if (!await dialog.confirm({ title: "Send the season-open email?", description: `This will email all ${data.total} talent pool members.`, confirmLabel: "Send Blast", destructive: false })) return;
    const { data: r } = await adminApi.post("/admin/talent-pool/blast", {});
    setSent(r.sent);
  };

  return (
    <AdminLayout title="Talent Pool" subtitle="Performers retained for future seasons"
      actions={
        <button onClick={blast} disabled={!data?.total} data-testid="blast-btn" className="flex items-center gap-2 px-4 py-2 text-xs uppercase tracking-wider bg-blood text-white hover:bg-[#FF3333] disabled:opacity-40 disabled:cursor-not-allowed">
          <Send size={14} /> Season Blast
        </button>
      }>
      {!data ? <Loader/> : (
        <>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-4">
            <div className="border border-[#1a1a1a] bg-[#0A0A0A] p-4">
              <div className="label-mini">Total in Pool</div>
              <div className="font-display text-3xl font-bold mt-2">{data.total}</div>
            </div>
            {sent !== null && (
              <div className="border border-[#10B981]/40 bg-[#10B981]/5 p-4">
                <div className="label-mini text-[#10B981]">Last Blast</div>
                <div className="font-display text-3xl font-bold mt-2 text-[#10B981]">{sent}</div>
                <div className="text-[10px] font-mono text-[#A19D94] mt-1 uppercase">emails sent</div>
              </div>
            )}
          </div>

          <div className="border border-[#1a1a1a] bg-[#0A0A0A]">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-[#1a1a1a] text-left">
                <th className="px-4 py-3 label-mini">Name</th><th className="px-4 py-3 label-mini">Email</th>
                <th className="px-4 py-3 label-mini">Experience</th><th className="px-4 py-3 label-mini">Submitted</th>
              </tr></thead>
              <tbody>
                {data.items.length === 0 && <tr><td colSpan={4} className="py-12 text-center text-[#6B6862]">No one in the talent pool yet.</td></tr>}
                {data.items.map((a) => (
                  <tr key={a.id} className="border-b border-[#1a1a1a]">
                    <td className="px-4 py-3">{a.full_name}</td>
                    <td className="px-4 py-3 text-[#A19D94] font-mono text-xs">{a.email}</td>
                    <td className="px-4 py-3 text-xs text-[#A19D94] max-w-xs truncate">{a.experience_level}</td>
                    <td className="px-4 py-3 font-mono text-xs text-[#A19D94]">{a.submitted_at?.slice(0,10)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}
    </AdminLayout>
  );
}
